import moment from "moment";

export const durationToTimeOfDay = (d) => {
  const m = moment(d.asMilliseconds()).startOf("day").add(d);

  return m.format("h:mm a");
};
